import { isDefined } from '@sgme/fp';
import { FormattedNumber } from 'react-intl';
import { Fragment } from 'react/jsx-runtime';

import { FormattedFXDate } from '@/components/ui/FormattedFXDate.tsx';

type GrowlLegsProps = {
  nameLabel: string;
  valueLabel: string;
  dateLabel: string;

  valuePrecision?: number;

  legs: GrowlSimpleLeg[];
};

export type GrowlSimpleLeg = {
  name: string;

  label: string;
  contraLabel?: string;
  value: number;

  date: string;
  tenor?: string;
  'data-e2e'?: string; // Optional for testing purposes
};

export const GrowlLegs = (props: GrowlLegsProps) => {
  const { nameLabel, valueLabel, dateLabel, valuePrecision, legs } = props;

  return (
    <div className="bg-primary bg-opacity-05 px-2 mt-1 fs-12">
      <table className="table table-sm table-borderless w-100">
        <thead>
          <tr className="p-4px">
            <th scope="col" className="text-start p-8px">
              {nameLabel}
            </th>

            <th scope="col" className="text-center p-8px">
              {valueLabel}
            </th>

            <th scope="col" className="text-end p-8px">
              {dateLabel}
            </th>
          </tr>
        </thead>

        <tbody>
          {/* Juste one cell all the row/colum */}
          {legs.map(({ name, label, value, contraLabel, date, tenor, 'data-e2e': dataE2e }, legIndex) => (
            // oxlint-disable-next-line no-array-index-key -- the legIndex is really the ID of the leg
            <Fragment key={legIndex}>
              <tr>
                <td colSpan={3} className="text-start text-secondary border-top" data-e2e="growl-option-leg-summary">
                  {name}
                </td>
              </tr>

              <tr>
                <th scope="row" data-e2e={`${dataE2e}-label`}>
                  <div>{label}</div>

                  {isDefined(contraLabel) && (
                    <div className="text-secondary" data-e2e={`${dataE2e}-contraLabel`}>
                      {contraLabel}
                    </div>
                  )}
                </th>

                <td className="text-center" data-e2e={`${dataE2e}-value`}>
                  <FormattedNumber
                    value={value}
                    minimumFractionDigits={valuePrecision}
                    maximumFractionDigits={valuePrecision}
                  />
                </td>

                <td className="text-end" data-e2e={`${dataE2e}-date`}>
                  <FormattedFXDate value={date} dateStyle="medium" />
                  {isDefined(tenor) ? ` (${tenor})` : ''}
                </td>
              </tr>
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};
